import { StyledSpinner } from '@tryhackme/thm-ui-components';
import { useEffect, useState } from 'react';
import { LoaderContainer, Message, MessageContainer, PhaseLabel, ProgressBarContainer, ProgressBarFill, ProgressBarWrapper, ProgressInfo, ProgressPercentage } from './loader.styles';
const defaultMessages = ['Loading...'];
const fallbackMessage = 'Loading...';
export const Loader = ({
  messages = defaultMessages,
  showLoadingMessages = false,
  sequentialMessages = false,
  easterEggMessages = [],
  progressBar
}: {
  showLoadingMessages?: boolean;
  messages?: string[];
  easterEggMessages?: string[];
  sequentialMessages?: boolean;
  progressBar?: {
    showLoadingMessages?: boolean;
    progress?: number;
  };
}) => {
  const [index, setIndex] = useState(sequentialMessages ? 0 : Math.floor(Math.random() * messages.length));
  const [currentMessage, setCurrentMessage] = useState(messages[index] ?? messages[0] ?? fallbackMessage);
  const getNextMessage = (currentIndex: number): {
    message: string;
    nextIndex: number;
  } => {
    // 1 in 50 chance to show an easter egg message
    const shouldShowEasterEgg = easterEggMessages.length > 0 && Math.random() < 1 / 50;
    if (shouldShowEasterEgg) {
      const randomEasterEgg = easterEggMessages[Math.floor(Math.random() * easterEggMessages.length)] ?? fallbackMessage;
      return {
        message: randomEasterEgg,
        nextIndex: currentIndex
      };
    }
    if (sequentialMessages) {
      const nextIndex = (currentIndex + 1) % messages.length;
      return {
        message: messages[nextIndex] ?? fallbackMessage,
        nextIndex
      };
    }
    const randomIndex = Math.floor(Math.random() * messages.length);
    return {
      message: messages[randomIndex] ?? fallbackMessage,
      nextIndex: randomIndex
    };
  };

  // biome-ignore lint/correctness/useExhaustiveDependencies: we do not want to re-run this effect when the messages change
  useEffect(() => {
    const interval = setInterval(() => {
      setIndex(prevIndex => {
        const {
          message,
          nextIndex
        } = getNextMessage(prevIndex);
        setCurrentMessage(message);
        return nextIndex;
      });
    }, 4000);
    return () => clearInterval(interval);
  }, [sequentialMessages, easterEggMessages.length]);
  return <LoaderContainer data-sentry-element="LoaderContainer" data-sentry-component="Loader" data-sentry-source-file="loader.tsx">
      <StyledSpinner size="10rem" color="rgb(238, 239, 242)" data-sentry-element="StyledSpinner" data-sentry-source-file="loader.tsx" />
      {showLoadingMessages && <MessageContainer>
          <i>
            <Message key={currentMessage}>&quot;{currentMessage}&quot;</Message>
          </i>
        </MessageContainer>}
      {progressBar && progressBar.progress !== undefined && <ProgressBarContainer>
          <ProgressInfo>
            {progressBar.showLoadingMessages && <PhaseLabel>{currentMessage}</PhaseLabel>}
            <ProgressPercentage>{progressBar.progress}%</ProgressPercentage>
          </ProgressInfo>
          <ProgressBarWrapper>
            <ProgressBarFill progress={progressBar.progress} />
          </ProgressBarWrapper>
        </ProgressBarContainer>}
    </LoaderContainer>;
};